import React, {useContext} from 'react';
import {Outlet, useLocation, Link} from 'react-router-dom';

import AccountSubmenu from './AccountSubmenu';

import moment from 'jalali-moment';

import GlobalConst from '../../../common/global-const';
import {ContextAuth} from '../../../common/context/context-auth';

import {Container, Row, Col, ListGroup} from 'react-bootstrap';

import {ReactComponent as ImgAccountFill} from '../../../asset/img/icon/account-fill.svg';
import {ReactComponent as ImgCustomerClub} from '../../../asset/img/icon/customer-club.svg';
import {ReactComponent as ImgAward} from '../../../asset/img/icon/award.svg';
import {ReactComponent as ImgTicket} from '../../../asset/img/icon/ticket.svg';
import {ReactComponent as ImgMicaCoin} from '../../../asset/img/icon/mica-coin.svg';
import {ReactComponent as ImgMicaPlus} from '../../../asset/img/icon/mica-plus.svg';
import {ReactComponent as ImgMicaTicket} from '../../../asset/img/icon/mica-ticket.svg';
import * as IconFi from 'react-icons/fi';

import './Account.scss'

const Account = () => {
    const location = useLocation()
    const auth = useContext(ContextAuth);

    const links = [
        {id: 1, title: 'باشگاه مشتریان', icon: <ImgCustomerClub className="sw-1 me-3"/>, child: [
                {id: 11, to: '/account/customer-club', title: 'جزئیات'},
                {id: 12, to: '/account/customer-club-invitees', title: 'دعوت شده ها'},
                {id: 13, to: '/account/customer-club-card-number', title: 'شماره کارت بانک'}
            ]
        },
        {id: 2, title: 'Mica Coin', icon: <ImgMicaCoin className="sw-1 me-3"/>, child: [
                {id: 21, to: '/account/mica-coin', title: 'جزئیات'},
                {id: 22, to: '/account/mica-coin-lottery', title: 'قرعه کشی'},
                {id: 23, to: '/account/mica-coin-discount-code', title: 'تخفیف'}
            ]
        },
        {id: 3, title: 'Mica Credit', icon: <ImgMicaPlus className="sw-1 me-3"/>, child: [
                {id: 31, to: '/account/mica-plus', title: 'جزئیات'},
            ]
        },
        {id: 4, title: 'Mica Cash', icon: <ImgMicaTicket className="sw-1 me-3"/>, child: [
                {id: 41, to: '/account/mica-ticket', title: 'جزئیات'},
            ]
        },
        {id: 5, to: '/account/expert-companion', title: 'همراه متخصص', icon: <ImgAward className="sw-1 me-3"/>},
        {id: 6, to: '/account/tickets', title: 'بلیط ها', icon: <ImgTicket className="sw-1 me-3"/>},
        {id: 7, to: '/account/profile', title: 'پروفایل', icon: <IconFi.FiUser size={24} className="sw-1 me-3"/>},
    ]

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <div id="pageAccount" className="mb-4 mb-xl-5 mt-4">
            <Container fluid="lg">
                <Row>
                    <Col xs={12}>
                        {
                            location.pathname === '/account' ? (
                                <>
                                    <div className="d-flex align-items-center">
                                        <figure className="mb-0 me-3 bg-elevate-8 rounded-square avatar"><ImgAccountFill width={42} height={42} fill="rgba(255, 255, 255, .12)"/></figure>
                                        <div>
                                            <span className="fs-4">{auth.user?.name ? `${auth.user.name} ${auth.user.last_name}` : 'کاربر مهمان'} گرامی</span>
                                            <div className="ls-half lh-1">0{auth.user?.mobile}</div>
                                        </div>
                                    </div>
                                    <ListGroup variant="flush" className="mt-4">
                                        {
                                            links.map((item, index) => {
                                                return (
                                                    item.child ? (
                                                        <React.Fragment key={item.id}><AccountSubmenu nav={item} slug={item.child[0].to}/></React.Fragment>
                                                    ) : (
                                                        <ListGroup.Item as={Link} to={item.to} className={`pe-0 ps-2 py-3 bg-transparent border-white-5 d-flex align-items-center${index === links.length - 1 ? ' border-bottom-0' : ''}`} key={item.id}>
                                                            {item.icon}
                                                            {item.title}
                                                            <IconFi.FiChevronLeft size={24} className="sw-1 ms-auto my-1 text-white text-opacity-18"/>
                                                        </ListGroup.Item>
                                                    )
                                                )
                                            })
                                        }
                                        <ListGroup.Item action type="button" className="pe-0 ps-2 py-3 bg-transparent border-white-5 d-flex align-items-center text-primary" onClick={() => auth.logout()}>
                                            <IconFi.FiLogOut size={24} className="sw-1 me-3 my-1 flip-h"/>
                                            <span className="fw-500">خروج</span>
                                        </ListGroup.Item>
                                    </ListGroup>
                                    <div className="text-muted mt-auto fs-11"><div className="lh-lg font-en">نسخه {GlobalConst.version}</div>© <span className="font-fa">{moment(new Date(), 'YYYY').locale('fa').format('YYYY')}</span> کلیه حقوق محفوظ و متعلق به {GlobalConst.owner} می باشد.</div>
                                </>
                            ) : (
                                <Outlet/>
                            )
                        }
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Account;